import React, { useEffect } from "react";

export default function UserListComponent({ users, setUsers }) {
  useEffect(() => {
    return () => {
      setUsers([]);
    };
  }, []);

  return (
    <div className="mt-2">
      {users
        ?.filter((user) => !user.deleted)
        .map((user) => (
          <div
            key={user.id}
            className="me-2 mb-2 d-flex justify-content-between align-items-center w-100 rounded p-2"
            style={{
              fontSize: "0.9rem",
              backgroundColor: "#FFF080",
              color: "#000000",
              border: "1px solid #e0e0e0",
            }}
          >
            <span>{user.name}</span>
            <button
              type="button"
              className="btn-no-bg text-dark"
              onClick={() => {
                user.deleted = true;
                setUsers([...users]);
              }}
            >
              <i className="icon-close"></i>
            </button>
          </div>
        ))}
    </div>
  );
}
